(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    const sectionId = drawer.closest('.shopify-section')?.id.replace('shopify-section-', '');
    let inner = drawer.querySelector('[data-cart-drawer-inner]');
    const liveRegion = drawer.querySelector('[data-cart-live-region]');
    // Bumped before every cart mutation, checked when its response comes back:
    // if a newer mutation (e.g. a quick remove right after an add) has already
    // started, this response is stale and must not overwrite the newer one.
    let requestSeq = 0;
    const headerCount = document.querySelector('[data-cart-count]');
    const headerCountLabel = document.querySelector('[data-cart-count-label]');

    if (!sectionId || !inner) return;

    window.GT_CART_SECTION_ID = sectionId;

    document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        drawer.showModal();
      });
    });

    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) drawer.close();
      if (event.target.closest('[data-cart-drawer-close]')) drawer.close();
    });

    function updateHeaderCount(count) {
      if (headerCount) {
        headerCount.textContent = String(count);
        headerCount.hidden = count === 0;
      }
      if (headerCountLabel?.dataset.template) {
        headerCountLabel.textContent = headerCountLabel.dataset.template.replace('__COUNT__', count);
      }
    }

    function applyCartResponse(cart, sectionsHtml, announceKey) {
      if (sectionsHtml && sectionsHtml[sectionId]) {
        const doc = new DOMParser().parseFromString(sectionsHtml[sectionId], 'text/html');
        const newInner = doc.querySelector('[data-cart-drawer-inner]');
        if (newInner) {
          inner.replaceWith(newInner);
          inner = newInner;
        }
      }
      updateHeaderCount(cart.item_count);
      if (liveRegion && announceKey) liveRegion.textContent = liveRegion.dataset[announceKey] || '';
    }

    async function changeLine(line, quantity) {
      const seq = ++requestSeq;
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity, sections: sectionId }),
      });
      const cart = await response.json();
      if (seq !== requestSeq) return;
      applyCartResponse(cart, cart.sections, quantity === 0 ? 'removedText' : 'updatedText');
    }

    drawer.addEventListener('click', (event) => {
      const row = event.target.closest('[data-cart-item]');
      if (!row) return;
      const line = parseInt(row.dataset.line, 10);
      const currentQuantity = parseInt(row.querySelector('[data-quantity-value]')?.textContent || '0', 10);

      if (event.target.closest('[data-quantity-increase]')) {
        changeLine(line, currentQuantity + 1);
      } else if (event.target.closest('[data-quantity-decrease]')) {
        changeLine(line, Math.max(currentQuantity - 1, 0));
      } else if (event.target.closest('[data-cart-remove]')) {
        changeLine(line, 0);
      }
    });

    drawer.addEventListener('click', async (event) => {
      const upsellAdd = event.target.closest('[data-cart-upsell-add]');
      if (!upsellAdd) return;
      const variantId = event.target.closest('[data-cart-upsell]')?.dataset.variantId;
      if (!variantId) return;

      const seq = ++requestSeq;
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1, sections: sectionId }),
      });
      const result = await response.json();
      const cartResponse = await (await fetch('/cart.js')).json();
      if (seq !== requestSeq) return;
      applyCartResponse(cartResponse, result.sections, 'addedText');
    });

    document.addEventListener('cart:item-added', async (event) => {
      const seq = ++requestSeq;
      const cart = await (await fetch('/cart.js')).json();
      if (seq === requestSeq) applyCartResponse(cart, event.detail?.sections, 'addedText');
      drawer.showModal();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-cart-page]');
    if (!root) return;

    const sectionId = root.closest('.shopify-section')?.id.replace('shopify-section-', '');
    let inner = root.querySelector('[data-cart-page-inner]');
    const liveRegion = root.querySelector('[data-cart-live-region]');
    const headerCount = document.querySelector('[data-cart-count]');
    const headerCountLabel = document.querySelector('[data-cart-count-label]');
    // Bumped before every cart mutation, checked when its response comes back:
    // if a newer mutation (e.g. a quick second click) has already started,
    // this response is stale and must not overwrite the newer one.
    let requestSeq = 0;

    if (!sectionId || !inner) return;

    function updateHeaderCount(count) {
      if (headerCount) {
        headerCount.textContent = String(count);
        headerCount.hidden = count === 0;
      }
      if (headerCountLabel?.dataset.template) {
        headerCountLabel.textContent = headerCountLabel.dataset.template.replace('__COUNT__', count);
      }
    }

    function applyCartResponse(cart, sectionsHtml, announceKey) {
      if (sectionsHtml && sectionsHtml[sectionId]) {
        const doc = new DOMParser().parseFromString(sectionsHtml[sectionId], 'text/html');
        const newInner = doc.querySelector('[data-cart-page-inner]');
        if (newInner) {
          inner.replaceWith(newInner);
          inner = newInner;
        }
      }
      updateHeaderCount(cart.item_count);
      if (liveRegion && announceKey) liveRegion.textContent = liveRegion.dataset[announceKey] || '';
    }

    async function changeLine(line, quantity) {
      const seq = ++requestSeq;
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity, sections: sectionId }),
      });
      const cart = await response.json();
      if (seq !== requestSeq) return;
      applyCartResponse(cart, cart.sections, quantity === 0 ? 'removedText' : 'updatedText');
    }

    root.addEventListener('click', (event) => {
      const row = event.target.closest('[data-cart-item]');
      if (!row) return;
      const line = parseInt(row.dataset.line, 10);
      const currentQuantity = parseInt(row.querySelector('[data-quantity-value]')?.textContent || '0', 10);

      if (event.target.closest('[data-quantity-increase]')) {
        changeLine(line, currentQuantity + 1);
      } else if (event.target.closest('[data-quantity-decrease]')) {
        changeLine(line, Math.max(currentQuantity - 1, 0));
      } else if (event.target.closest('[data-cart-remove]')) {
        changeLine(line, 0);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-toolbar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const form = document.getElementById('CollectionFilterForm');
    if (!form) return;

    const sortSelect = form.querySelector('[data-sort-select]');
    sortSelect?.addEventListener('change', () => form.requestSubmit());

    form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      checkbox.addEventListener('change', () => form.requestSubmit());
    });

    const filterToggle = document.querySelector('[data-filter-toggle]');
    const drawer = document.getElementById('CollectionFilterDrawer');
    const rail = document.getElementById('CollectionFilterRail');

    if (filterToggle && drawer) {
      const drawerClose = document.querySelector('[data-filter-drawer-close]');
      filterToggle.addEventListener('click', () => {
        drawer.showModal();
        filterToggle.setAttribute('aria-expanded', 'true');
      });
      drawer.addEventListener('close', () => filterToggle.setAttribute('aria-expanded', 'false'));
      drawerClose?.addEventListener('click', () => drawer.close());
      drawer.addEventListener('click', (event) => {
        if (event.target === drawer) drawer.close();
      });
    } else if (filterToggle && rail) {
      filterToggle.addEventListener('click', () => {
        const expanded = filterToggle.getAttribute('aria-expanded') === 'true';
        filterToggle.setAttribute('aria-expanded', String(!expanded));
        rail.hidden = expanded;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const grid = document.querySelector('[data-collection-grid]');
    const list = grid?.querySelector('[data-product-list]');
    const pagination = grid?.querySelector('[data-pagination]');
    const loadMoreButton = grid?.querySelector('[data-load-more]');
    const progressBar = grid?.querySelector('[data-progress-bar]');
    const countText = grid?.querySelector('[data-count-text]');

    if (!grid || !list || !pagination || !loadMoreButton) return;

    const totalItems = parseInt(pagination.dataset.totalItems, 10);
    const sectionId = grid.closest('.shopify-section')?.id.replace('shopify-section-', '');

    function updateProgress() {
      const loaded = list.children.length;
      if (progressBar) {
        const percent = Math.min((loaded / totalItems) * 100, 100);
        progressBar.style.setProperty('--progress', `${percent}%`);
      }
      if (countText) {
        countText.textContent = countText.dataset.countTemplate
          .replace('__LOADED__', loaded)
          .replace('__TOTAL__', totalItems);
      }
    }

    function addSkeletons(count) {
      const nodes = [];
      for (let i = 0; i < count; i++) {
        const li = document.createElement('li');
        li.className = 'collection-grid__skeleton';
        li.setAttribute('aria-hidden', 'true');
        li.innerHTML =
          '<span class="gt-placeholder"></span>' +
          '<span class="collection-grid__skeleton-line"></span>' +
          '<span class="collection-grid__skeleton-line" style="width:40%"></span>';
        list.appendChild(li);
        nodes.push(li);
      }
      return nodes;
    }

    loadMoreButton.addEventListener('click', async () => {
      const nextUrl = pagination.dataset.nextUrl;
      if (!nextUrl || !sectionId) return;

      loadMoreButton.disabled = true;
      loadMoreButton.setAttribute('aria-busy', 'true');
      const skeletons = addSkeletons(4);

      try {
        const separator = nextUrl.includes('?') ? '&' : '?';
        const response = await fetch(`${nextUrl}${separator}section_id=${sectionId}`);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        skeletons.forEach((node) => node.remove());
        doc.querySelectorAll('[data-product-list] > li').forEach((node) => list.appendChild(node));

        const newPagination = doc.querySelector('[data-pagination]');
        pagination.dataset.nextUrl = newPagination?.dataset.nextUrl || '';

        updateProgress();

        if (!pagination.dataset.nextUrl) {
          loadMoreButton.remove();
        }
      } finally {
        loadMoreButton.disabled = false;
        loadMoreButton.removeAttribute('aria-busy');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('[data-carousel-track]');
      const prev = carousel.querySelector('[data-carousel-prev]');
      const next = carousel.querySelector('[data-carousel-next]');
      if (!track || !prev || !next) return;

      const scrollByItem = (direction) => {
        const item = track.querySelector('.featured-products__item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const amount = item.getBoundingClientRect().width + gap;
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      };

      prev.addEventListener('click', () => scrollByItem(-1));
      next.addEventListener('click', () => scrollByItem(1));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const dialog = document.getElementById('MobileNav');
    const toggle = document.querySelector('[data-mobile-nav-toggle]');
    const closeButton = document.querySelector('[data-mobile-nav-close]');

    if (!dialog || !toggle) return;

    toggle.addEventListener('click', () => dialog.showModal());
    closeButton?.addEventListener('click', () => dialog.close());

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gallery"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      const main = gallery.querySelector('[data-gallery-main]');
      const thumbnails = gallery.querySelectorAll('[data-gallery-thumbnail]');
      if (!main || thumbnails.length === 0) return;

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const target = gallery.querySelector(`#${thumbnail.dataset.target}`);
          target?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      });

      const items = gallery.querySelectorAll('[data-gallery-item]');
      if (items.length === 0) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            thumbnails.forEach((thumbnail) => {
              thumbnail.setAttribute('aria-current', String(thumbnail.dataset.target === entry.target.id));
            });
          });
        },
        { root: main, threshold: 0.6 }
      );

      items.forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
